exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._3NPjBvbR7_ZzzIlMcrow-A{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;height:1.42857rem;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;width:1.42857rem}._1BxDI3qc-6XrqZnQwqtZp_{display:block;font-size:1.42857rem}._1BxDI3qc-6XrqZnQwqtZp_.-VJy4ZEGaPq5hWa7YH7Wz{color:#74d17f}._1BxDI3qc-6XrqZnQwqtZp_._3mG4YVE5gM0G5ZZtNGzS-{color:#de4c4c}._1BxDI3qc-6XrqZnQwqtZp_._3_PSg819NJ8uOEUbZgfAfg{color:#f7932d}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"PaperBasedBall": "_3NPjBvbR7_ZzzIlMcrow-A",
	"PaperBasedBall_img": "_1BxDI3qc-6XrqZnQwqtZp_",
	"__complete": "-VJy4ZEGaPq5hWa7YH7Wz",
	"__incomplete": "_3mG4YVE5gM0G5ZZtNGzS-",
	"__partialComplete": "_3_PSg819NJ8uOEUbZgfAfg"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/Homework/PaperBased/MarkHomeworkCourseView/PaperFolding/style.postcss
// module id = 1657
// module chunks = 0